import React from 'react';
import Card from './Card.js';
import '../App.css';
import { getUILoc } from '../utils/cardUtils.js';
import audioManager from '../utils/AudioManager.js';

const Field = ({ playerName, cards, fieldLimit, onProvideInput, awaiting_input, onCardClick, onAnimationEnd }) => {
    if (!playerName) return <div className="field">{getUILoc('MESSAGES.LOADING')}</div>;

    const isChoiceForEffect = awaiting_input?.type === 'CHOICE_CARD_FOR_EFFECT';
    const selectableCardIds = isChoiceForEffect 
        ? new Set(awaiting_input.options.map(c => c.instance_id)) 
        : new Set();

    const handleCardClick = (card) => {
        audioManager.playSE('select');
        if (onCardClick) {
            onCardClick(card);
        } else if (selectableCardIds.has(card.instance_id)) {
            onProvideInput(card);
        }
    };

    // Derive all card types from the single 'cards' prop
    const allPresentedCards = cards || [];
    
    // 3: Ideology
    const activeIdeology = allPresentedCards.find(c => c.card_type === 3 && !c.animation);
    
    // 3: Ideology, animation === 'destroying'
    const animatingIdeology = allPresentedCards.find(c => c.card_type === 3 && c.animation === 'destroying');

    // 1: Wealth
    const wealthCards = allPresentedCards.filter(card => card.card_type === 1);
    const activeWealthCardsCount = wealthCards.filter(c => !c.animation).length;

    return (
        <div className="field">
            <h4>{getUILoc('MESSAGES.PLAYER_FIELD', { name: playerName })}</h4>
            
            <div className="field-area">
                <div className="field-label">
                    <span className="ideology-indicator">{getUILoc('CARD_TYPES.3')}</span>
                    <span className="wealth-indicator">
                        {getUILoc('CARD_TYPES.1')} ({activeWealthCardsCount}/{fieldLimit})
                        <span className="placement-order-hint">{getUILoc('LABELS.PLACEMENT_ORDER_HINT')}</span>
                    </span>
                </div>
                
                <div className="field-cards-container">
                    <div className="ideology-slot">
                        {activeIdeology && (
                            <Card 
                                card={activeIdeology} 
                                mode="game"
                                isSelectable={selectableCardIds.has(activeIdeology.instance_id)}
                                onClick={() => handleCardClick(activeIdeology)}
                                onAnimationEnd={onAnimationEnd}
                                location="field"
                            />
                        )}
                        {animatingIdeology && (
                             <Card 
                                card={animatingIdeology} 
                                mode="game"
                                isSelectable={false} 
                                onClick={() => {}}
                                onAnimationEnd={onAnimationEnd}
                                location="field"
                            />
                        )}
                        {!activeIdeology && !animatingIdeology && (
                            <div className="empty-ideology-slot">
                                <span>{getUILoc('CARD_TYPES.3')}</span>
                            </div>
                        )}
                    </div>

                    <div className="wealth-cards-scrollable">
                        {wealthCards.map(card => (
                            <div key={card.instance_id} className="wealth-card-slot">
                                <Card 
                                    card={card} 
                                    mode="game"
                                    isSelectable={selectableCardIds.has(card.instance_id)}
                                    onClick={() => handleCardClick(card)}
                                    onAnimationEnd={onAnimationEnd}
                                    location="field"
                                />
                            </div>
                        ))}
                        {Array.from({ length: Math.max(0, fieldLimit - wealthCards.length) }).map((_, index) => (
                            <div key={`empty-${index}`} className="wealth-card-slot">
                                <div className="empty-wealth-slot">
                                    <span className="slot-number">{wealthCards.length + index + 1}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Field;
